import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import MessageCard from '../../../../Components/Accounts/Message/MessageCard/MessageCard'
import Section from '../../../../Components/Section/Section'
import '../../../../Components/Accounts/Message/message.css'
import MessageSidebar from '../../../../Components/Accounts/Message/MessageSidebar/MessageSidebar'
import MessageUserCard from '../../../../Components/Accounts/Message/MessageUserCard/MessageUserCard'
import MessageWindow from '../../../../Components/Accounts/Message/MessageWindow/MessageWindow'
import ScrollableFeed from 'react-scrollable-feed'
import MessageData from '../../../../Components/Accounts/Message/MessageData/MessageData'
import MessageWritingBox from '../../../../Components/Accounts/Message/MessageWritingBox/MessageWritingBox'
import MessageInputBox from '../../../../Components/Accounts/Message/MessageInputBox/MessageInputBox'
import SubmitBox from '../../../../Components/Accounts/Message/SubmitBox/SubmitBox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from 'react'
import { getUserDetailsCookie } from '../../../../Api/Utils/apiUtils'
import { setUserDeActiveOnChat, chatDatabase, createSelectedRoomNewMessage, getCurrentUserChatrooms, setUserActiveOnChat } from '../../../../Api/Utils/chatUtils'
import { ref, onValue, } from "firebase/database";
import NoConversation from '../../../../Components/Accounts/Message/NoConversation/NoConversation'

const MessageComponent = () => {
    const [message, setmessage] = useState('')
    const [messageNavigationList, setmessageNavigationList] = useState([]);
    const [userName, setuserName] = useState("");
    const [userId, setuserId] = useState('');
    const [currentMessageID, setcurrentMessageID] = useState('');
    const [messagelist, setmessagelist] = useState([]);
    const [isSupplier, setisSupplier] = useState(false);
    const [messageOponent, setmessageOponent] = useState('');
    const [messageActive, setmessageActive] = useState(false);


    useEffect(() => {
        const loadChatroom = async () =>{
            const user = getUserDetailsCookie()
            setisSupplier(user.userBusinessIsActive)
            setuserName(`${user.firstName} ${user.lastName}`)
            setuserId(`${user.id}`)
            if (user.userBusinessIsActive) {
                const chatroom = await getCurrentUserChatrooms(user.id, 1)
                setmessageNavigationList(chatroom)
            }else{
                const chatroom = await getCurrentUserChatrooms(user.id, 0)
                setmessageNavigationList(chatroom)
            }
        }
        loadChatroom()
        onValue(ref(chatDatabase, `chatRooms/${currentMessageID}/messages`), (snapshot) => {
            if (snapshot.val()) {
                const valus = Object.values(snapshot.val())
                setmessagelist(valus)
            }
        })

        const user = getUserDetailsCookie();
        setUserActiveOnChat(user.id)
    }, [currentMessageID]);

    function resetTimer() {
        const user = getUserDetailsCookie()
        setUserActiveOnChat(user.id)
        setTimeout(() => {
            setUserDeActiveOnChat(user.id)
        }, 60000);
    }

    //set status
        window.onload = resetTimer;
        window.onmousemove = resetTimer;
        window.onmousedown = resetTimer;
        window.ontouchstart = resetTimer;
        window.onclick = resetTimer;
        window.onkeypress = resetTimer;

    async function getChatRoomMessages(link, currentChatroomData) {
        if (isSupplier) {
            setmessageOponent(currentChatroomData.chatroomInfo.mBuyerName)
        }else{
            setmessageOponent(currentChatroomData.chatroomInfo.mSupplierName)
        }
        setcurrentMessageID(link)
        setmessageActive(true)
    }

    function sendmessage() {
        createSelectedRoomNewMessage(currentMessageID, message, userName, userId)
        setmessage('')
    }


    function getsomeWord(sentence) {
        if (sentence.length > 36) {
            const sortsentence = sentence.split(' ')
            let sentancedata = ""
            for (let i = 0; i < 6; i++) {
                sentancedata = `${sentancedata} ${sortsentence[i]}`
            }
            return `${sentancedata}....`
        }else{
            return `${sentence}`
        }
    }

    return (
        <Section>
            <Container>
                <MessageCard>
                    <MessageSidebar>
                        {messageNavigationList && messageNavigationList.length > 0 &&
                            messageNavigationList.map((chatroom, index) => (
                                <MessageUserCard key={`MESSAGE${index}`} isActive={false} userAvatar={`./img/avatar.png`} userName={isSupplier? chatroom.chatroomInfo.mBuyerName : chatroom.chatroomInfo.mSupplierName} getChatRoomData={getChatRoomMessages} roomLink={`${chatroom.customer}-${chatroom.supplier}`} currentChatroomData={chatroom} userID={isSupplier? chatroom.customer : chatroom.supplier} />
                            ))
                        }
                    </MessageSidebar>
                    {messageActive ?
                    <MessageWindow 
                    messageUserAvatar={`./img/avatar.png`} 
                    messageUserName={messageOponent} 
                    lastMessage={messagelist.length > 0 && getsomeWord(messagelist[messagelist.length - 1].mText)}>
                        <ScrollableFeed>
                            {// this is a demo message array that neeed to chnage with real message data
                            messagelist.map((ele, index) => {
                                if(ele.mText === messagelist[0].mText){
                                    return(
                                        <MessageData key={`MESSAGEDATA${index}`} isMyMessage={false} include={true} messagedata={ele.mText} isSeen={ele.mIsRead} messageTime={ele.mTimestamp} />
                                    )
                                }else if(ele.mUserId === userId){
                                    return(
                                        <MessageData key={`MESSAGEDATA${index}`} isMyMessage={true} messagedata={ele.mText} isSeen={ele.mIsRead} messageTime={ele.mTimestamp} />
                                    )
                                }
                                else{
                                    return(
                                        <MessageData key={`MESSAGEDATA${index}`} isMyMessage={false} messagedata={ele.mText} messageTime={ele.mTimestamp} />
                                    )
                                }
                            })
                            }
                        </ScrollableFeed>
                        <MessageWritingBox>
                            <MessageInputBox>
                                <input type="text" onKeyDown={(e) => e.key === "Enter" && sendmessage()} value={message}  onChange={(e) => setmessage(e.target.value)}/>
                            </MessageInputBox>
                            <SubmitBox>
                                <button onClick={sendmessage}>
                                    <FontAwesomeIcon icon={faPaperPlane} /> <span>Send</span> 
                                </button>
                            </SubmitBox>
                        </MessageWritingBox>
                    </MessageWindow>
                    :
                    <NoConversation />
                    }
                </MessageCard>
            </Container>
        </Section>
    )
}

export default MessageComponent
